import React, { createContext } from 'react'
import { localStorage } from 'lib/core/services/localStorage'

interface ComparisonContextInterface {
  addProductToCompare: (product: string) => boolean
  getProductsToCompare: () => string[]
  removeProduct: (index: number) => void
}

export const ComparisonContext = createContext<ComparisonContextInterface>({
  addProductToCompare: (sku: string) => true,
  getProductsToCompare: () => [],
  removeProduct: (index: number) => undefined
})

export const ComparisonProvider: React.FC = ({ children }) => {
  const addProductToCompare = (sku: string) => {
    const productsToCompare = getProductsToCompare()
    const newProductsToCompare = [] as string[]
    let changed = false

    productsToCompare.forEach((productToCompare: string, index: number) => {
      if (productToCompare === '' && !changed) {
        newProductsToCompare[index] = sku
        changed = true
      } else {
        newProductsToCompare[index] = productToCompare
      }
    })
    localStorage.set('comparisonProducts', newProductsToCompare)

    return changed
  }

  const getProductsToCompare = () => {
    let productsToCompare = localStorage.get('comparisonProducts') ?? []
    if (productsToCompare?.length <= 0) {
      productsToCompare = ['', '', '', '']
      localStorage.set('comparisonProducts', productsToCompare)
    }

    return productsToCompare
  }

  const removeProduct = (index: number) => {
    const productsToCompare = getProductsToCompare()
    productsToCompare.splice(index, 1)
    productsToCompare.push('')

    localStorage.set('comparisonProducts', productsToCompare)
  }

  return (
    <ComparisonContext.Provider
      value={{
        addProductToCompare,
        getProductsToCompare,
        removeProduct
      }}
    >
      {children}
    </ComparisonContext.Provider>
  )
}

export const useComparisonContext = () => {
  const context = React.useContext(ComparisonContext)
  if (context === undefined) {
    throw new Error('useComparisonContext must be used within a ComparisonProvider')
  }
  return context
}
